var initHeroDottedLines = require("./gsap-animations/hero-dotted-line");
var leftStickySection = require("./gsap-animations/sticky");
var serviceAnim = require("./gsap-animations/service-animation");

jQuery(document).ready(function ($) {
  var gsapInstance = window.gsap;
  var scrollTriggerInstance = window.ScrollTrigger;
  var $sequenceGroups = $(
    '[data-gsap-group="fade-up-sequence"], .js-gsap-fade-up-sequence',
  );
  var $singleElements = $('[data-gsap="fade-up"], .js-gsap-fade-up');
  var $characterElements = $(
    '[data-gsap="chars-fade-up"], .js-gsap-chars-fade-up',
  );
  var $lineGrowElements = $('[data-gsap="line-grow"], .js-gsap-line-grow');
  var prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (!gsapInstance || !scrollTriggerInstance) {
    return;
  }

  gsapInstance.registerPlugin(scrollTriggerInstance);

  function getNumberValue(value, fallbackValue) {
    var parsedValue = parseFloat(value);

    return isNaN(parsedValue) ? fallbackValue : parsedValue;
  }

  function getBooleanValue(value, fallbackValue) {
    if (typeof value !== "string") {
      return fallbackValue;
    }

    var normalizedValue = value.toLowerCase().trim();

    if (
      normalizedValue === "true" ||
      normalizedValue === "1" ||
      normalizedValue === "yes"
    ) {
      return true;
    }

    if (
      normalizedValue === "false" ||
      normalizedValue === "0" ||
      normalizedValue === "no"
    ) {
      return false;
    }

    return fallbackValue;
  }

  function sortGroupItems(items) {
    return items.sort(function (firstItem, secondItem) {
      var firstOrder = getNumberValue(
        firstItem.getAttribute("data-gsap-order"),
        999,
      );
      var secondOrder = getNumberValue(
        secondItem.getAttribute("data-gsap-order"),
        999,
      );

      return firstOrder - secondOrder;
    });
  }

  function prepareCharacterTargets(element) {
    if (element.getAttribute("data-gsap-chars-ready") === "true") {
      return Array.prototype.slice.call(element.querySelectorAll(".gsap-char"));
    }

    var accessibleText = (element.textContent || "")
      .replace(/\s+/g, " ")
      .trim();

    if (!accessibleText.length) {
      element.setAttribute("data-gsap-chars-ready", "true");
      return [];
    }

    element.setAttribute("role", "text");
    element.setAttribute("aria-label", accessibleText);

    splitNodeCharacters(element);

    element.setAttribute("data-gsap-chars-ready", "true");

    return Array.prototype.slice.call(element.querySelectorAll(".gsap-char"));
  }

  function splitNodeCharacters(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (childNode) {
      if (childNode.nodeType === 3) {
        var textValue = childNode.textContent || "";

        if (!textValue.length) {
          return;
        }

        if (!textValue.trim().length) {
          childNode.parentNode.removeChild(childNode);
          return;
        }

        var fragment = document.createDocumentFragment();

        Array.from(textValue).forEach(function (character) {
          var span = document.createElement("span");

          span.className = "gsap-char";
          span.setAttribute("aria-hidden", "true");
          span.textContent = /\s/.test(character) ? "\u00A0" : character;

          fragment.appendChild(span);
        });

        childNode.parentNode.replaceChild(fragment, childNode);
        return;
      }

      if (
        childNode.nodeType === 1 &&
        childNode.tagName !== "SCRIPT" &&
        childNode.tagName !== "STYLE"
      ) {
        splitNodeCharacters(childNode);
      }
    });
  }

  function resolveAnimationTrigger(element, $element) {
    var triggerClosestSelector = $element.attr("data-gsap-trigger-closest");
    var triggerSelector = $element.attr("data-gsap-trigger-selector");
    var triggerElement = element;

    if (triggerClosestSelector && typeof element.closest === "function") {
      try {
        triggerElement =
          element.closest(triggerClosestSelector) || triggerElement;
      } catch (error) {
        triggerElement = element;
      }
    } else if (triggerSelector) {
      try {
        triggerElement =
          document.querySelector(triggerSelector) || triggerElement;
      } catch (error) {
        triggerElement = element;
      }
    }

    return triggerElement;
  }

  function showCharacterElement(element) {
    element.style.removeProperty("visibility");
  }

  function revealWithoutAnimation(targets) {
    gsapInstance.set(targets, {
      opacity: 1,
      y: 0,
      clearProps: "opacity,transform",
    });
  }

  function resetFadeUpTargets(targets, yValue) {
    gsapInstance.set(targets, {
      opacity: 0,
      y: yValue,
    });
  }

  function createRepeatableFadeUpAnimation(triggerElement, targets, options) {
    var animationOptions = {
      opacity: 1,
      y: 0,
      duration: options.duration,
      ease: options.ease,
      clearProps: "opacity,transform",
      paused: true,
    };

    if (typeof options.stagger !== "undefined") {
      animationOptions.stagger = options.stagger;
    }

    if (typeof options.delay !== "undefined") {
      animationOptions.delay = options.delay;
    }

    resetFadeUpTargets(targets, options.y);

    var animation = gsapInstance.to(targets, animationOptions);

    function restartAnimation() {
      animation.restart();
    }

    function resetAnimation() {
      animation.pause(0);
      resetFadeUpTargets(targets, options.y);
    }

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: options.start,
      onEnter: restartAnimation,
      onEnterBack: restartAnimation,
    });

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: "top bottom",
      end: "bottom top",
      onLeave: resetAnimation,
      onLeaveBack: resetAnimation,
    });
  }

  function revealLineWithoutAnimation(target) {
    gsapInstance.set(target, {
      scaleX: 1,
      clearProps: "transform",
    });
  }

  function resetLineGrowTarget(target) {
    gsapInstance.set(target, {
      scaleX: 0,
      transformOrigin: "left center",
    });
  }

  function createRepeatableLineGrowAnimation(triggerElement, target, options) {
    resetLineGrowTarget(target);

    var animation = gsapInstance.to(target, {
      scaleX: 1,
      duration: options.duration,
      ease: options.ease,
      clearProps: "transform",
      paused: true,
    });

    function restartAnimation() {
      animation.restart();
    }

    function resetAnimation() {
      animation.pause(0);
      resetLineGrowTarget(target);
    }

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: options.start,
      onEnter: restartAnimation,
      onEnterBack: restartAnimation,
    });

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: "top bottom",
      end: "bottom top",
      onLeave: resetAnimation,
      onLeaveBack: resetAnimation,
    });
  }

  function createRepeatableCharacterAnimation(
    triggerElement,
    targets,
    options,
  ) {
    resetFadeUpTargets(targets, options.y);

    var animation = gsapInstance.timeline({
      paused: true,
    });

    animation.to(targets, {
      opacity: 1,
      y: 0,
      duration: options.duration,
      delay: options.delay || 0,
      stagger: options.stagger,
      ease: options.ease,
      clearProps: "opacity,transform",
    });

    function restartAnimation() {
      animation.restart();
    }

    function resetAnimation() {
      animation.pause(0);
      resetFadeUpTargets(targets, options.y);
    }

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: options.start,
      onEnter: restartAnimation,
      onEnterBack: restartAnimation,
    });

    scrollTriggerInstance.create({
      trigger: triggerElement,
      start: "top bottom",
      end: "bottom top",
      onLeave: resetAnimation,
      onLeaveBack: resetAnimation,
    });
  }

  $sequenceGroups.each(function () {
    var $group = $(this);
    var items = sortGroupItems(
      $group.find("[data-gsap-item], .js-gsap-item").get(),
    );
    var stickyItems = [];
    var yValue = getNumberValue($group.attr("data-gsap-y"), 48);
    var durationValue = getNumberValue($group.attr("data-gsap-duration"), 0.8);
    var delayValue = getNumberValue($group.attr("data-gsap-delay"), 0);
    var staggerValue = getNumberValue(
      $group.attr("data-gsap-delay-step"),
      0.18,
    );
    var startValue = $group.attr("data-gsap-start") || "top 85%";
    var easeValue = $group.attr("data-gsap-ease") || "power2.out";
    var repeatAnimation = getBooleanValue(
      $group.attr("data-gsap-repeat"),
      false,
    );

    if ($group.hasClass("text-left-sticky")) {
      stickyItems = $group.find(".column-tt-col.left").get();
      items = items.filter(function (item) {
        return stickyItems.indexOf(item) === -1;
      });

      if (stickyItems.length) {
        revealWithoutAnimation(stickyItems);
      }
    }

    if (!items.length) {
      return;
    }

    if (prefersReducedMotion) {
      revealWithoutAnimation(items);
      return;
    }

    if (repeatAnimation) {
      createRepeatableFadeUpAnimation(this, items, {
        start: startValue,
        y: yValue,
        duration: durationValue,
        ease: easeValue,
        delay: delayValue,
        stagger: staggerValue,
      });
      return;
    }

    gsapInstance.set(items, {
      opacity: 0,
      y: yValue,
    });

    gsapInstance.to(items, {
      opacity: 1,
      y: 0,
      duration: durationValue,
      delay: delayValue,
      stagger: staggerValue,
      ease: easeValue,
      clearProps: "opacity,transform",
      scrollTrigger: {
        trigger: this,
        start: startValue,
        once: true,
      },
    });
  });

  $singleElements
    .filter(function () {
      return !$(this).closest(
        '[data-gsap-group="fade-up-sequence"], .js-gsap-fade-up-sequence',
      ).length;
    })
    .each(function () {
      var $element = $(this);
      var yValue = getNumberValue($element.attr("data-gsap-y"), 48);
      var durationValue = getNumberValue(
        $element.attr("data-gsap-duration"),
        0.8,
      );
      var delayValue = getNumberValue($element.attr("data-gsap-delay"), 0);
      var startValue = $element.attr("data-gsap-start") || "top 85%";
      var easeValue = $element.attr("data-gsap-ease") || "power2.out";
      var repeatAnimation = getBooleanValue(
        $element.attr("data-gsap-repeat"),
        false,
      );

      if (prefersReducedMotion) {
        revealWithoutAnimation(this);
        return;
      }

      if (repeatAnimation) {
        createRepeatableFadeUpAnimation(this, this, {
          start: startValue,
          y: yValue,
          duration: durationValue,
          ease: easeValue,
          delay: delayValue,
        });
        return;
      }

      gsapInstance.fromTo(
        this,
        {
          opacity: 0,
          y: yValue,
        },
        {
          opacity: 1,
          y: 0,
          duration: durationValue,
          delay: delayValue,
          ease: easeValue,
          clearProps: "opacity,transform",
          scrollTrigger: {
            trigger: this,
            start: startValue,
            once: true,
          },
        },
      );
    });

  $characterElements.each(function () {
    var $element = $(this);
    var characterTargets = prepareCharacterTargets(this);
    var triggerElement = resolveAnimationTrigger(this, $element);
    var yValue = getNumberValue($element.attr("data-gsap-y"), 24);
    var durationValue = getNumberValue(
      $element.attr("data-gsap-duration"),
      0.34,
    );
    var delayValue = getNumberValue($element.attr("data-gsap-delay"), 0);
    var staggerValue = getNumberValue(
      $element.attr("data-gsap-delay-step"),
      0.012,
    );
    var startValue = $element.attr("data-gsap-start") || "top 95%";
    var easeValue = $element.attr("data-gsap-ease") || "power3.out";
    var repeatAnimation = getBooleanValue(
      $element.attr("data-gsap-repeat"),
      false,
    );

    if (!characterTargets.length) {
      return;
    }

    if (prefersReducedMotion) {
      showCharacterElement(this);
      revealWithoutAnimation(characterTargets);
      return;
    }

    if (repeatAnimation) {
      showCharacterElement(this);
      createRepeatableCharacterAnimation(triggerElement, characterTargets, {
        start: startValue,
        y: yValue,
        duration: durationValue,
        ease: easeValue,
        delay: delayValue,
        stagger: staggerValue,
      });
      return;
    }

    gsapInstance.set(characterTargets, {
      opacity: 0,
      y: yValue,
    });
    showCharacterElement(this);

    gsapInstance.to(characterTargets, {
      opacity: 1,
      y: 0,
      duration: durationValue,
      delay: delayValue,
      stagger: staggerValue,
      ease: easeValue,
      clearProps: "opacity,transform",
      scrollTrigger: {
        trigger: triggerElement,
        start: startValue,
        once: true,
      },
    });
  });

  $lineGrowElements.each(function () {
    var $element = $(this);
    var durationValue = getNumberValue(
      $element.attr("data-gsap-duration"),
      0.35,
    );
    var startValue = $element.attr("data-gsap-start") || "top 95%";
    var easeValue = $element.attr("data-gsap-ease") || "power2.out";
    var repeatAnimation = getBooleanValue(
      $element.attr("data-gsap-repeat"),
      false,
    );

    if (prefersReducedMotion) {
      revealLineWithoutAnimation(this);
      return;
    }

    if (repeatAnimation) {
      createRepeatableLineGrowAnimation(this, this, {
        start: startValue,
        duration: durationValue,
        ease: easeValue,
      });
      return;
    }

    gsapInstance.fromTo(
      this,
      {
        scaleX: 0,
        transformOrigin: "left center",
      },
      {
        scaleX: 1,
        duration: durationValue,
        ease: easeValue,
        clearProps: "transform",
        scrollTrigger: {
          trigger: this,
          start: startValue,
          once: true,
        },
      },
    );
  });

  initHeroDottedLines({
    gsapInstance: gsapInstance,
    prefersReducedMotion: prefersReducedMotion,
  });

  leftStickySection({
    jQuery: $,
    scrollTriggerInstance: scrollTriggerInstance,
  });

  serviceAnim({
    jQuery: $,
    scrollTriggerInstance: scrollTriggerInstance,
  });

  requestAnimationFrame(() => {
    scrollTriggerInstance.refresh(true);
  });
});
